import { BreakOption } from '@types';
import {
  CreateWorkTemplatePayload,
  CreateWorkTemplateResponse,
  GetBreakOptionsResponse,
  GetFilteredWorkTemplatesListingParams,
  GetFilteredWorkTemplatesListingResponse,
  UpdateWorkTemplatePayload,
} from './work-template-service.types';
import { OgpApiService } from './ogp-api-service';

export class WorkTemplateService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  /**
   * Create a new work template
   */
  public createWorkTemplate = async (
    workTemplate: CreateWorkTemplatePayload
  ): Promise<CreateWorkTemplateResponse> => {
    return await this.ogpApiService.create<CreateWorkTemplateResponse>({
      body: workTemplate,
      path: `jobs`,
    });
  };

  /**
   * Update an existing work template
   */
  public updateWorkTemplate = async (id: string, params: UpdateWorkTemplatePayload) => {
    await this.ogpApiService.update({
      body: params,
      path: `jobs/${id}`,
    });
  };

  public getFilteredWorkTemplatesListing = async (
    params: GetFilteredWorkTemplatesListingParams
  ): Promise<GetFilteredWorkTemplatesListingResponse> => {
    const response = await this.ogpApiService.get<GetFilteredWorkTemplatesListingResponse>({
      path: 'jobs/listing',
      params,
    });

    return response;
  };

  public getBreakOptions = async (workTemplateId: string): Promise<BreakOption[]> => {
    const response = await this.ogpApiService.get<GetBreakOptionsResponse>({
      path: `jobs/${workTemplateId}/break`,
    });

    return response.breakOptions;
  };

  public archiveWorkTemplate = async (workTemplateId: string) =>
    await this.ogpApiService.delete<undefined>({
      path: `jobs/${workTemplateId}`,
    });
}
